import Fetch from "@/utils/Fetch"

export default {
	namespaced: true,
	state() {
		return {
			productsUnits: JSON.parse(localStorage.getItem('products-units')) || null,
			productGroups: null,
			productGroupsSupplier: null
		}
	},
	mutations: {
		setState(state, {key, value}) {
			if (!(key in state)) return
			state[key] = value
		},
		setProductGroups(state, value) {
			state.productGroups = value.filter(item => 'children' in item);
		},

		updateProductGroups(state, {productId, products}) {
			const newProductGroups = state.productGroups.find(el => el.children?.some(child => child.id === productId))
			newProductGroups.children.find(child => child.id === productId).products = products
		},
		updateProductGroupsSupplier(state, {productId, products}) {
			const newProductGroups = state.productGroupsSupplier.find(el => el.children?.some(child => child.id === productId))
			newProductGroups.children.find(child => child.id === productId).products = products
		},

	},
	actions: {
		async requestProductsUnits({commit, state, dispatch}) {
			if(state.productsUnits) return

			commit('startLoading', 'requestProductsUnits', {root: true})

			const response = await Fetch('units/', {})

			if (response.success) {
				commit('setState', {key: 'productsUnits', value: response.data})
				localStorage.setItem('products-units', JSON.stringify(response.data))
			} else {
				dispatch('showError', response.message, {root: true})
			}

			commit('stopLoading', 'requestProductsUnits', {root: true})

			return {
				...response.data
			}
		},

		async requestProductGroups({commit, getters, dispatch}, authorized) {
			if(!getters.getProductGroups) {
				commit('startLoading', 'requestProductGroups', {root: true})

				const response = await Fetch(authorized ? 'product-groups/' : 'product-groups/all/ ', {})

				if (response.success) {
					commit('setProductGroups', response.data)
					// sessionStorage.setItem('product-groups', JSON.stringify(response.data))
				} else {
					dispatch('showError', response.message, {root: true})
				}

				commit('stopLoading', 'requestProductGroups', {root: true})

				return {
					...response.data
				}
			}
		},

		async requestProducts({commit, dispatch}, id) {
			commit('startLoading', 'requestProducts', {root: true})

			const response = await Fetch(`products/?productGroups=${id}`, {})

			if (response.success) {

				commit('updateProductGroups', {productId: id, products: response.data[0].products, })
			} else {
				dispatch('showError', response.message, {root: true})
			}

			commit('stopLoading', 'requestProducts', {root: true})

			return {
				...response.data
			}
		},


		async requestProductGroupsSupplier({commit, dispatch}, id) {
			const response = await Fetch(`products/get/${id}/`, {})

			if (response.success) {
				commit('setState', {key: 'productGroupsSupplier', value: response.data})
			} else {
				dispatch('showError', response.message, {root: true})
			}

			return {
				...response.data
			}
		},

		async requestProductsSupplier({commit, dispatch}, id) {
			const response = await Fetch(`products/?productGroups=${id}`, {})
			if (response.success) {
				commit('updateProductGroupsSupplier', {productId: id, products: response.data[0].products, })
			} else {
				dispatch('showError', response.message, {root: true})
			}
			return {
				...response.data
			}
		},


	},

	getters: {
		getProductsUnits: state => state.productsUnits,
		getProductGroups: state => state.productGroups,
		getProductGroupsSupplier: state => state.productGroupsSupplier,
	}
}

